import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { DocumentType } from 'document/model/document.type';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface CreateDocumentOrganizationModuleParams {
	readonly locale: string;
	readonly coacheeId: string;
	readonly documentName: string;
	readonly documentType: DocumentType;
	readonly documentUrl: string;
	readonly editable: boolean;
	readonly moduleDescription: string;
	readonly moduleTitle: string;
}

@Injectable({ providedIn: 'root' })
export class CreateDocumentOrganizationModuleApiMutation extends ApiMutation<
	string,
	CreateDocumentOrganizationModuleParams
> {
	client = 'content';
	document = gql`
		mutation CreateDocumentOrganizationModule(
			$locale: String!
			$coacheeId: UUID
			$documentName: String!
			$documentType: DocumentType!
			$documentUrl: String!
			$editable: Boolean!
			$moduleDescription: String
			$moduleTitle: String!
		) {
			createDocumentOrganizationModule(
				locale: $locale
				coacheeId: $coacheeId
				documentName: $documentName
				documentType: $documentType
				documentUrl: $documentUrl
				editable: $editable
				moduleDescription: $moduleDescription
				moduleTitle: $moduleTitle
			)
		}
	`;
	method = 'createDocumentOrganizationModule';
}
